import { Navtex } from '../models/vessel-rs1345-model';
import { authFetchGET, FetchStatusCodeError } from '../utils/auth-fetch';

const env = (<any>window).appenv;

export interface Rs1345UpdateInfo {
    licensed: boolean,
    week: string | null
}

export class Rs1345Service {
    static async getUpdateInfo(): Promise<Map<string, Rs1345UpdateInfo>> {
        const enableTides = (<any>window)["appenv"]?.featureToggles?.tides;
        if (!enableTides) {
            return new Map<string, Rs1345UpdateInfo>();
        }
        const result = await authFetchGET(env.scope, `${env.services.rs1345.baseurl}/updateInfo`);
        return new Map(Object.entries(result));
    }

    static async getNavtex(): Promise<Navtex[]> {
        const enableTides = (<any>window)["appenv"]?.featureToggles?.tides;
        if (!enableTides) {
            return [];
        }
        const result: Navtex[] = await authFetchGET(env.scope, `${env.services.rs1345.baseurl}/navtex`);
        return result;
    }

    static async getHtml(address: string): Promise<string> {
        const enableTides = (<any>window)["appenv"]?.featureToggles?.tides;
        if (!enableTides) {
            return "";
        }
        let request: RequestInit = {
            mode: 'cors',
            cache: 'no-cache',
            method: 'GET',
            headers: { 'Accept': 'text/html' }
        };

        const searchParams = new URLSearchParams();
        searchParams.set("address", address);        
            
        const searchString = `?${searchParams.toString()}`;
        const response = await fetch(`${env.services.rs1345.baseurl}/html${searchString}`, request);

        if (response.status < 200 || response.status >= 300) {
            throw new FetchStatusCodeError(response, `Error fetching data: ${response.statusText}`);
        }
        
        const result = await response.text();
        return result;
    }
}